exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".O9oW9{background-color:#fff;color:#0b91cf}.qQ2mF{margin:0 auto;padding:16px 0 16px 16px;padding:1rem 0 1rem 1rem;max-width:1000px}@media screen and (min-width:992px){.qQ2mF{padding-left:0;padding-right:0}}", ""]);

// exports
exports.locals = {
	"root": "O9oW9",
	"container": "qQ2mF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Header/Header.css
// module id = 539
// module chunks = 0 1 2 3 4